// ============================================================================
// AUDIT (Auditoria de Dados Cadastrais)
// ============================================================================
export const AUDIT_SEVERITY_LABELS = {
    0: 'Sem divergência',
    1: 'Formatação',
    2: 'Leve',
    3: 'Moderada',
    4: 'Significativa',
    5: 'Crítica',
};
export const AUDIT_SEVERITY_DESCRIPTIONS = {
    0: 'Dados idênticos após normalização',
    1: 'Diferença mínima de formatação (acentos, plural, espaços) — não contabilizada',
    2: 'Diferença de abreviações ou espaços (80–95%)',
    3: 'Divergência moderada (60–80%)',
    4: 'Divergência significativa (30–60%)',
    5: 'Endereços completamente diferentes ou campo ausente (<30%)',
};
//# sourceMappingURL=audit.js.map